import React from 'react';
import { BaseConfigProps } from '../shared/ConfigFormHelpers';

const CRMQueryConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  const config = node.data.config || {};
  const queryType = config?.queryType || 'all_customers';
  const taskStatus = config?.taskStatus || 'pending';
  const customerStatus = config?.customerStatus || 'active';
  const includeInactive = config?.includeInactive || false;
  const limit = config?.limit || 100;
  const sortBy = config?.sortBy || 'createdAt';
  const sortOrder = config?.sortOrder || 'desc';

  const handleChange = (field: string, value: any) => {
    updateConfig(field, value);
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Lekérdezés típusa
        </label>
        <select
          value={queryType}
          onChange={(e) => handleChange('queryType', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500 dark:bg-gray-700 dark:text-gray-100"
        >
          <option value="all_customers">Összes ügyfél (szűrésekkel)</option>
          <option value="customers_with_open_tasks">Ügyfelek nyitott task-okkal</option>
          <option value="customers_by_status">Ügyfelek státusz szerint</option>
        </select>
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Válaszd ki, milyen ügyfeleket szeretnél lekérdezni
        </p>
      </div>

      {queryType === 'customers_with_open_tasks' && (
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Task státusz
          </label>
          <select
            value={taskStatus}
            onChange={(e) => handleChange('taskStatus', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500 dark:bg-gray-700 dark:text-gray-100"
          >
            <option value="pending">Függőben (pending)</option>
            <option value="in_progress">Folyamatban (in_progress)</option>
            <option value="submitted">Beküldött (submitted)</option>
            <option value="all_open">Minden nyitott</option>
          </select>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Csak azokat az ügyfeleket adja vissza, akiknek ilyen státuszú task-ja van
          </p>
        </div>
      )}

      {(queryType === 'all_customers' || queryType === 'customers_by_status') && (
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Ügyfél státusz
          </label>
          <select
            value={customerStatus}
            onChange={(e) => handleChange('customerStatus', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500 dark:bg-gray-700 dark:text-gray-100"
          >
            <option value="all">Minden</option>
            <option value="active">Aktív</option>
            <option value="inactive">Inaktív</option>
          </select>
        </div>
      )}

      {queryType === 'all_customers' && (
        <>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Rendezés
            </label>
            <div className="grid grid-cols-2 gap-2">
              <select
                value={sortBy}
                onChange={(e) => handleChange('sortBy', e.target.value)}
                className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500 dark:bg-gray-700 dark:text-gray-100"
              >
                <option value="createdAt">Létrehozás dátuma</option>
                <option value="updatedAt">Módosítás dátuma</option>
                <option value="companyName">Cégnév</option>
              </select>
              <select
                value={sortOrder}
                onChange={(e) => handleChange('sortOrder', e.target.value)}
                className="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500 dark:bg-gray-700 dark:text-gray-100"
              >
                <option value="desc">Csökkenő</option>
                <option value="asc">Növekvő</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Limit (max ügyfelek száma)
            </label>
            <input
              type="number"
              value={limit}
              onChange={(e) => handleChange('limit', parseInt(e.target.value) || 100)}
              min="1"
              max="1000"
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500 dark:bg-gray-700 dark:text-gray-100"
            />
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Maximum {limit} ügyfél kerül lekérdezésre
            </p>
          </div>
        </>
      )}

      <div className="flex items-center">
        <input
          type="checkbox"
          id="includeInactive"
          checked={includeInactive}
          onChange={(e) => handleChange('includeInactive', e.target.checked)}
          className="h-4 w-4 text-purple-600 focus:ring-purple-500 border-gray-300 rounded"
        />
        <label htmlFor="includeInactive" className="ml-2 block text-sm text-gray-700 dark:text-gray-300">
          Inaktív ügyfelek is
        </label>
      </div>

      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-3">
        <h4 className="text-sm font-medium text-blue-900 dark:text-blue-100 mb-2">
          📥 Bemenet (Input)
        </h4>
        <div className="space-y-1">
          <div className="flex items-start space-x-2">
            <span className="text-xs font-mono bg-white dark:bg-gray-800 px-2 py-0.5 rounded border border-blue-200 dark:border-blue-700">trigger</span>
            <span className="text-xs text-blue-700 dark:text-blue-300">Opcionális - Trigger esemény (pl. Schedule)</span>
          </div>
        </div>
      </div>

      <div className="bg-purple-50 dark:bg-purple-900/20 border border-purple-200 dark:border-purple-800 rounded-lg p-3">
        <h4 className="text-sm font-medium text-purple-900 dark:text-purple-100 mb-2">
          📤 Kimenet (Output)
        </h4>
        <div className="space-y-2">
          <div className="flex items-start space-x-2">
            <span className="text-xs font-mono bg-white dark:bg-gray-800 px-2 py-0.5 rounded border border-purple-200 dark:border-purple-700">customers</span>
            <span className="text-xs text-purple-700 dark:text-purple-300">Array - Ügyfelek listája</span>
          </div>
          <pre className="text-xs bg-white dark:bg-gray-800 p-2 rounded border border-purple-200 dark:border-purple-700 overflow-x-auto">
{`{
  "customers": [
    {
      "id": "customer123",
      "name": "Példa Kft.",
      "email": "info@example.com",
      "contactPersons": [...]
    }
  ],
  "count": 10
}`}
          </pre>
        </div>
      </div>

      <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-3">
        <h4 className="text-sm font-medium text-yellow-900 dark:text-yellow-100 mb-1">
          💡 Használat
        </h4>
        <p className="text-xs text-yellow-700 dark:text-yellow-300">
          Kösd össze egy Loop node-dal, hogy minden ügyfélre végrehajts valamit (pl. email küldés).
        </p>
      </div>
    </div>
  );
};

export default CRMQueryConfig;
